"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createKonvaStage;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createKonvaStage({ container = "container", width = 640, height = 480, interactive = true, style = {}, onMouseDown = ()=>{}, onTouchStart = ()=>{}, onContextMenu = ()=>{} }) {
    const stage = new _konva.default.Stage({
        container,
        width,
        height
    });
    stage.on("mousedown touchstart", onMouseDown);
    stage.on("contextmenu", (e)=>{
        e.evt.preventDefault(); // prevent default context menu
        onContextMenu(e);
    });
    stage.container().style.cursor = style.cursor;
    stage.listening(interactive); // set listening property
    return stage;
}
